import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class CustomerController extends BaseController {
  model = DataConst.MODELS.CUSTOMER;
}

export default new CustomerController();
